import { useEffect, useState } from "react";
import { fetchData } from "../lib/dataCache";

const DATE_FORMAT = { month: "short", day: "numeric", year: "numeric" };
const TIME_FORMAT = { hour: "numeric", minute: "2-digit" };
const LOCALE = "en-US";

const parseTimestamp = (value) => {
  const date = value ? new Date(value) : null;
  return date && !Number.isNaN(date.getTime()) ? date : null;
};

// A date-only string parsed as UTC midnight would render a day early west of UTC.
const parseExportedDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
};

const toAtlasVersion = (entry) => ({
  version: entry.version || null,
  exported: parseExportedDate(entry.exported),
  loaded: parseTimestamp(entry.loaded),
});

// The vendor's export date when recorded, else the load time; null when neither is known.
export const formatAtlasDataVersionLabel = (atlas) => {
  const when = atlas ? atlas.exported || atlas.loaded : null;
  const version = atlas?.version ? atlas.version.replace(/^v?/i, "v") : null;
  const source = version ? `Atlas ${version}` : "Atlas";
  const date = when ? when.toLocaleDateString(LOCALE, DATE_FORMAT) : null;
  // An export date has no time of day; only a load timestamp does.
  const time = when && !atlas.exported ? ` at ${when.toLocaleTimeString(LOCALE, TIME_FORMAT)}` : "";
  return atlas && (version || when)
    ? `Showing data from ${source}${date ? `, last updated ${date}${time}` : ""}.`
    : null;
};

// `datasets.atlas` from GET /api/health: null until fetched, on failure, or when not yet reported.
export const useAtlasDataVersion = () => {
  const [atlas, setAtlas] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchData("/api/health")
      .then((body) => {
        const entry = body?.datasets?.atlas;
        return cancelled || !entry || entry.status ? null : setAtlas(toAtlasVersion(entry));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return atlas;
};
